import { z } from 'zod'

export const nexHealthLocationSchema = z
  .object({
    id: z.number().int().positive(),
    name: z.string().min(1).max(200),
  })
  .strict()

export const nexHealthOnboardingResponseSchema = z
  .object({
    revision: z.number().int().positive(),
    connectionStatus: z.enum(['NOT_CONNECTED', 'CONNECTED', 'ACTION_REQUIRED']),
    subdomain: z.string().nullable(),
    locations: z.array(nexHealthLocationSchema).max(100),
    selectedLocationId: z.number().int().positive().nullable(),
    discoveryRevision: z.number().int().nonnegative(),
    canReconnect: z.boolean(),
    canRetryDiscovery: z.boolean(),
    errorCode: z
      .enum([
        'credential_rejected',
        'nexhealth_unavailable',
        'no_locations',
        'location_payload_invalid',
        'internal_error',
      ])
      .nullable(),
  })
  .strict()

export type NexHealthOnboardingResponse = z.infer<
  typeof nexHealthOnboardingResponseSchema
>
